import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DetailsForm } from './-components/details-form';
import { ProfilePictureSection } from './-components/profile-picture-section';
import {
  SettingsSection,
  SettingsSectionSkeleton,
} from './-components/settings-section';
import { accountSettingsQueryOptions } from './-utils/account-settings-query';
import { SETTINGS_HELP } from './-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/details',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      accountSettingsQueryOptions(context.user.id),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: DetailsPage,
  head: () => ({ meta: [{ title: t`Details` }] }),
});

function DetailsPage() {
  const { user } = Route.useRouteContext();
  const { data: settings } = useSuspenseQuery(
    accountSettingsQueryOptions(user.id),
  );

  return (
    <div className="flex flex-col gap-6">
      <SettingsSection
        helpUrl={SETTINGS_HELP.general}
        title={t`Personal details`}
        description={t`Your name, contact details and employment.`}
      >
        <ProfilePictureSection user={user} />
        <DetailsForm settings={settings} userId={user.id} />
      </SettingsSection>
    </div>
  );
}
